import React from 'react'
import { useTranslation } from 'react-i18next'
import { DashboardWidget } from 'features/widget/types'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import ErrorMessage from '../../../share/ErrorMessage'
import { dataNotReturned } from '../utils/dataNotReturnedChecker'

const isAllDataNotReturned = (widgetData: DashboardWidget<AnnotatedMetricResult>) =>
  widgetData.data.every(dataNotReturned)

const NoDataReturnedGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<AnnotatedMetricResult>(widgetId)
  const { t } = useTranslation()

  if (isAllDataNotReturned(widgetData)) {
    return <ErrorMessage>{t('noDataFilterSet')}</ErrorMessage>
  }

  return children
}

export default NoDataReturnedGuard
